var _rect, _path, _rect2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg4Azul(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 50,
    viewBox: "0 0 75 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 50,
    rx: 4,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.9166C12.2072 10.9166 12.8855 11.1976 13.3856 11.6977C13.8857 12.1978 14.1666 12.876 14.1666 13.5833C14.1666 14.2905 13.8857 14.9688 13.3856 15.4689C12.8855 15.969 12.2072 16.25 11.5 16.25C10.7927 16.25 10.1144 15.969 9.61434 15.4689C9.11424 14.9688 8.83329 14.2905 8.83329 13.5833C8.83329 12.876 9.11424 12.1978 9.61434 11.6977C10.1144 11.1976 10.7927 10.9166 11.5 10.9166M11.5 17.5833C14.4466 17.5833 16.8333 18.7766 16.8333 20.25V21.5833H6.16663V20.25C6.16663 18.7766 8.55329 17.5833 11.5 17.5833Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 9.75,
    width: 45.5,
    height: 30.25,
    rx: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 28.4166C12.2072 28.4166 12.8855 28.6976 13.3856 29.1977C13.8857 29.6978 14.1666 30.376 14.1666 31.0833C14.1666 31.7905 13.8857 32.4688 13.3856 32.9689C12.8855 33.469 12.2072 33.75 11.5 33.75C10.7927 33.75 10.1144 33.469 9.61434 32.9689C9.11424 32.4688 8.83329 31.7905 8.83329 31.0833C8.83329 30.376 9.11424 29.6978 9.61434 29.1977C10.1144 28.6976 10.7927 28.4166 11.5 28.4166M11.5 35.0833C14.4466 35.0833 16.8333 36.2766 16.8333 37.75V39.0833H6.16663V37.75C6.16663 36.2766 8.55329 35.0833 11.5 35.0833Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4Azul);
export default __webpack_public_path__ + "static/media/img4azul.4fbfd5fcf2eda59ecff4a9f8767f8623.svg";
export { ForwardRef as ReactComponent };